var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavoriteRemovedcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 26,
  viewBox: "0 0 34 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M4 9.4l.3-1.2a7 7 0 0 1 11.7-3l1 1 1-1a7 7 0 0 1 3.7-2 7 7 0 0 1 8 4.8 7 7 0 0 1-1.8 7.2l-5.1 5.3-5.1 5.1c-.5.5-1 .5-1.4 0L6.2 15.3a7.3 7.3 0 0 1-2.1-4l-.1-.5V9.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#017CB9",
  d: "M3 3.2a.5.5 0 1 0-.4-.9.5.5 0 0 0 0 .8.5.5 0 0 0 .3.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#017CB9",
  d: "M25 13.9c1.4-2 2-3.7 2-5.1C27 3.9 23.4 0 19 0c-2 0-4 .8-5.5 2.3A7.7 7.7 0 0 0 8 0a7.5 7.5 0 0 0-3.6 1 .5.5 0 0 0-.2.7.5.5 0 0 0 .7.2A6.4 6.4 0 0 1 8 1c2 0 3.8.8 5.1 2.4a.5.5 0 0 0 .8 0 6.6 6.6 0 0 1 5-2.4c4 0 7 3.4 7 7.7 0 1.2-.5 2.7-1.6 4.4a6.4 6.4 0 0 0-3.8-1.2C17 12 14 14.9 14 18.5a6.5 6.5 0 0 0 1.3 3.9 63.2 63.2 0 0 1-1.8 1.4c-.9-.6-3.5-2.7-6.1-5.2-4.2-4-6.3-7.4-6.3-9.8 0-1.5.3-2.9 1-4.1A.5.5 0 0 0 2 4a.5.5 0 0 0-.7.2A9.3 9.3 0 0 0 0 8.7c0 2.8 2.2 6.4 6.6 10.7 3.3 3.1 6.6 5.5 6.6 5.5a.5.5 0 0 0 .6 0l2.2-1.7a6.5 6.5 0 0 0 4.5 1.8 6.5 6.5 0 0 0 4.6-11.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M23.7 17.6h-6.3a.5.5 0 0 0-.6.5v1c0 .2.3.5.6.5h6.3a.5.5 0 0 0 .5-.6v-.9a.5.5 0 0 0-.5-.5"
}))));
export default SvgFavoriteRemovedcom;